function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { CheckIcon, CopyIcon, IconButton, Input, InputGroup, Popover, ShareIcon } from '@hypothesis/frontend-shared';
import { useCallback, useEffect, useRef, useState } from 'preact/hooks';
import { isPrivate } from '../helpers/permissions';
import { useTimeout } from '../hooks/use-timeout';
import { isIOS } from '../utils/user-agent';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
function selectionOverflowsInputElement() {
  // On iOS the selection overflows the input element
  // See: https://github.com/hypothesis/client/pull/2799
  return isIOS();
}

/**
 * Retrieve an appropriate sharing link for this annotation.
 *
 * If the annotation is on a shareable document (i.e. its document is
 * web-accessible), prefer the `incontext` (bouncer) link, but fallback to the
 * `html` (single-annotation `h` web view) link if needed.
 *
 * If the annotation is not on a shareable document, don't use the `incontext`
 * link as that won't work; only use the single-annotation-view `html` link.
 *
 * Note that `html` links are not provided by the service for third-party
 * annotations.
 */
function annotationSharingLink(annotation, isShareableURI) {
  if (isShareableURI) {
    var _ref, _annotation$links$inc, _annotation$links, _annotation$links2;
    return (_ref = (_annotation$links$inc = (_annotation$links = annotation.links) === null || _annotation$links === void 0 ? void 0 : _annotation$links.incontext) !== null && _annotation$links$inc !== void 0 ? _annotation$links$inc : (_annotation$links2 = annotation.links) === null || _annotation$links2 === void 0 ? void 0 : _annotation$links2.html) !== null && _ref !== void 0 ? _ref : null;
  } else {
    var _annotation$links$htm, _annotation$links3;
    return (_annotation$links$htm = (_annotation$links3 = annotation.links) === null || _annotation$links3 === void 0 ? void 0 : _annotation$links3.html) !== null && _annotation$links$htm !== void 0 ? _annotation$links$htm : null;
  }
}

/**
 * Share button which opens a Popover for sharing a single annotation.
 */
export default function AnnotationShareControl(_ref2) {
  var annotation = _ref2.annotation,
    group = _ref2.group,
    onCopy = _ref2.onCopy;
  var annotationIsPrivate = isPrivate(annotation.permissions);
  var inContextAvailable = /^http(s?):/i.test(annotation.uri);
  var shareURI = annotationSharingLink(annotation, inContextAvailable);
  var inputRef = useRef(null);
  var shareRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var wasOpen = useRef(isOpen);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    copied = _useState4[0],
    setCopied = _useState4[1];
  var setTimeout = useTimeout();
  var copyShareLink = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return navigator.clipboard.writeText(shareURI);
        case 1:
          setCopied(true);
          setTimeout(function () {
            return setCopied(false);
          }, 1500);
          onCopy === null || onCopy === void 0 || onCopy({
            ok: true,
            value: shareURI
          });
          _context.n = 3;
          break;
        case 2:
          _context.p = 2;
          _t = _context.v;
          onCopy === null || onCopy === void 0 || onCopy({
            ok: false,
            error: _t
          });
        case 3:
          return _context.a(2);
      }
    }, _callee, null, [[0, 2]]);
  })), [onCopy, setTimeout, shareURI]);
  var toggleSharePanel = function toggleSharePanel() {
    return setOpen(function (prev) {
      return !prev;
    });
  };
  useEffect(function () {
    if (wasOpen.current !== isOpen) {
      wasOpen.current = isOpen;
      if (isOpen && !selectionOverflowsInputElement()) {
        var _inputRef$current, _inputRef$current2;
        // Panel was just opened: select and focus the share URI for convenience
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.select();
      }
    }
  }, [isOpen]);
  if (!group || !shareURI) {
    return null;
  }

  // Generate some descriptive text about who may see the annotation if they
  // follow the share link.
  // First: Based on the type of the group the annotation is in, who would
  // be able to view it?
  var groupSharingInfo = group.type === 'private' ? _jsxs("span", {
    children: ["Only members of the group ", _jsx("em", {
      children: group.name
    }), " may view this annotation."]
  }) : _jsx("span", {
    children: "Anyone using this link may view this annotation."
  });

  // However, if the annotation is marked as "only me" (`annotationIsPrivate` is `true`),
  // then group sharing settings are irrelevant—only the author may view the
  // annotation.
  var annotationSharingInfo = annotationIsPrivate ? _jsx("span", {
    children: "Only you may view this annotation."
  }) : groupSharingInfo;
  return _jsxs("div", {
    className: "relative",
    ref: shareRef,
    children: [_jsx(IconButton, {
      icon: ShareIcon,
      title: "Share",
      onClick: toggleSharePanel,
      expanded: isOpen
    }), _jsx(Popover, {
      open: isOpen,
      onClose: function onClose() {
        return setOpen(false);
      },
      anchorElementRef: shareRef,
      align: "right",
      placement: "above",
      arrow: true,
      classes:
      // Set explicit width for browsers not supporting native popover API
      // eslint-disable-next-line no-prototype-builtins
      !HTMLElement.prototype.hasOwnProperty('popover') ? 'w-max' : undefined,
      children: _jsxs("div", {
        className: "p-2 flex flex-col gap-y-2",
        children: [_jsx("h2", {
          className: "text-brand text-[14px] font-medium",
          children: "Share this annotation"
        }), _jsx("div", {
          className: "flex w-full text-[13px]",
          children: _jsxs(InputGroup, {
            children: [_jsx(Input, {
              "aria-label": "Use this URL to share this annotation",
              type: "text",
              value: shareURI,
              readOnly: true,
              elementRef: inputRef
            }), _jsx(IconButton, {
              icon: copied ? CheckIcon : CopyIcon,
              title: "Copy share link to clipboard",
              onClick: copyShareLink,
              variant: "dark"
            })]
          })
        }), _jsx("div", {
          className: "text-[13px] font-normal",
          "data-testid": "share-details",
          children: inContextAvailable ? _jsx(_Fragment, {
            children: annotationSharingInfo
          }) : _jsx(_Fragment, {
            children: "This annotation cannot be shared in its original context because it was made on a document that is not available on the web. This link shares the annotation by itself."
          })
        })]
      })
    })]
  });
}
//# sourceMappingURL=AnnotationShareControl.js.map